import { render, staticRenderFns } from "./statistic-ranks.vue?vue&type=template&id=6498f02e"
import script from "./statistic-ranks.vue?vue&type=script&lang=js"
export * from "./statistic-ranks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports